import { http } from './http'
import { LocaleDescriptionText, Stage } from '../../common/models'

export type Pagination<T> = {
  content: T[]
  totalElements: number
  totalPages: number
  size: number
  pageNumber: number
  empty: boolean
}

export type LocaleObject = { [key: string]: string }

export type PaginationParams = {
  page?: number
  size?: number
  sortBy?: string
  sortDirection?: 'ASC' | 'DESC'
}

export interface MapType {
  id: string
  name: string
  published: boolean
  pinImageUrl: string
}

export interface MapTypeDetails {
  id: string
  localeName: LocaleDescriptionText
  published: boolean
  pinImageUrl: string
  filterImageUrl: string
}

export interface MapLocation {
  id: string
  translations: ITranslation[]
  type: MapType
  longitude: string
  latitude: string
  stage: Stage
  published: true
}

export interface AllMapLocations {
  id: string
  locationType: string
  name: string
  stage: string
  longitude: string
  latitude: string
  published: boolean
  festivalId: string
}

export interface MapTypePayload {
  localeName: LocaleObject
  published: boolean
  pinImageUrl?: string
  filterImageUrl?: string
}

export interface ITranslation {
  locale: string
  name: string
  description: string
}

export interface MapLocationPayload {
  typeId: string
  stageId?: string
  longitude: string
  latitude: string
  published: boolean
  translations: ITranslation[]
}

export interface PatchPayload {
  ids: string[]
}

export const mapTypes = (params?: PaginationParams) =>
  http.get<Pagination<MapType>>('/operations/map-location-types', {
    params,
  })

export const createType = (data: MapTypePayload) =>
  http.post<MapType>('/operations/map-location-types', data)

export const updateType = (id: string, data: MapTypePayload) =>
  http.put<MapType>(`/operations/map-location-types/${id}`, data)

export const unpublishType = (data: PatchPayload) =>
  http.put<MapType[]>('/operations/map-location-types/unpublish', data)

export const publishType = (data: PatchPayload) =>
  http.put<MapType[]>('/operations/map-location-types/publish', data)

export const deleteType = (ids: string[]) =>
  http.delete('/operations/map-location-types', {
    data: {
      ids,
    },
  })

export const getType = (id: string) =>
  http.get<MapTypeDetails>(`/operations/map-location-types/${id}`)

export const mapLocations = (params?: PaginationParams) =>
  http.get<Pagination<AllMapLocations>>('/operations/map-locations', {
    params,
  })

export const createLocation = (data: MapLocationPayload) =>
  http.post<MapLocation>('/operations/map-locations', data)

export const getLocation = (id: string) =>
  http.get<MapLocation>(`/operations/map-locations/${id}`)

export const updateLocation = (id: string, data: MapLocationPayload) =>
  http.put<MapLocation>(`/operations/map-locations/${id}`, data)

export const publishLocations = (data: PatchPayload) =>
  http.put<MapLocation[]>('/operations/map-locations/publish', data)

export const unpublishLocations = (data: PatchPayload) =>
  http.put<MapLocation[]>('/operations/map-locations/unpublish', data)

export const deleteLocations = (ids: string[]) =>
  http.delete('/operations/map-locations', {
    data: {
      ids,
    },
  })
